module.exports = __webpack_public_path__ + "images/aee6758485b48540ac2e297216b6aa8f.svg";